"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _AccordionContext = _interopRequireDefault(require("./AccordionContext"));
var _AccordionCollapse = _interopRequireDefault(require("./AccordionCollapse"));
var _AccordionProvider = _interopRequireDefault(require("./AccordionProvider"));
var _excluded = ["className", "children", "eventKey", "as"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Accordion/index.js";
function Accordion(_ref) {
  var className = _ref.className,
    children = _ref.children,
    eventKey = _ref.eventKey,
    Comp = _ref.as,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useContext = _react["default"].useContext(_AccordionContext["default"]),
    handleToggle = _React$useContext.handleToggle;
  var classes = (0, _classNames["default"])(className, 'accordion-toggle collapsed');
  return /*#__PURE__*/_react["default"].createElement(Comp, Object.assign({
    className: classes,
    onClick: handleToggle,
    href: '#' + eventKey + '-collapse',
    "data-bs-toggle": "collapse",
    "aria-expanded": "true"
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 9
    }
  }), children);
}
Accordion.defaultProps = {
  as: 'a'
};
Accordion.Collapse = _AccordionCollapse["default"];
Accordion.Provider = _AccordionProvider["default"];
var _default = exports["default"] = Accordion;